import React from 'react';
import { Sparkles } from 'lucide-react';
interface DemoFillBannerProps {
  onFill: () => void;
  /** Optional override copy. Defaults to a generic message. */
  message?: string;
  className?: string;
}
/**
 * Dashed "Demo mode" banner with a Fill sample data action.
 * Reused on every section page so stakeholders can prefill any screen
 * in one click during walkthroughs.
 */
export function DemoFillBanner({
  onFill,
  message = 'Demo mode — auto-fill this section with sample data.',
  className = ''
}: DemoFillBannerProps) {
  return <div className={`flex items-center justify-between gap-3 p-3 rounded-lg bg-gray-50 border border-dashed border-gray-300 ${className}`} data-id="element-956">
      <div className="flex items-center gap-2 text-xs text-gray-600 min-w-0" data-id="element-957">
        <Sparkles className="w-4 h-4 text-gray-700 flex-shrink-0" aria-hidden="true" data-id="element-958" />
        <span className="truncate" data-id="element-959">{message}</span>
      </div>
      <button type="button" onClick={onFill} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-900 text-white text-xs font-semibold hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 transition-colors flex-shrink-0" data-id="element-960">
        <Sparkles className="w-3.5 h-3.5" aria-hidden="true" data-id="element-961" />
        Fill sample data
      </button>
    </div>;
}